var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewFireiconRed = function SvgNewFireiconRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 0c3.978 2.21 3.5 8.437 3.5 8.437s1.75-.562 1.75-3.093C12.588 6.51 14 8.755 14 11.25 14 14.978 10.866 18 7 18s-7-3.022-7-6.75C0 5.766 5.25 4.64 5.25 0Z",
    fill: "url(#new_fireicon_red_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "new_fireicon_red_svg__a",
    x1: 7,
    y1: 0,
    x2: 7,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931A"
  })))));
};
export { SvgNewFireiconRed as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTQnIGhlaWdodD0nMTgnICB2aWV3Qm94PSIwIDAgMTQgMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01LjI1MDAyIDBDOS4yMjgwOCAyLjIxMDIyIDguNzUwMDIgOC40Mzc0OSA4Ljc1MDAyIDguNDM3NDlDOC43NTAwMiA4LjQzNzQ5IDEwLjUgNy44NzQ5OSAxMC41IDUuMzQzNzZDMTIuNTg3OSA2LjUxMTE4IDE0IDguNzU1MDYgMTQgMTEuMjVDMTQgMTQuOTc3OSAxMC44NjYgMTggNyAxOEMzLjEzNCAxOCAwIDE0Ljk3NzkgMCAxMS4yNUMzLjcxOTMzZS0wNSA1Ljc2NTYzIDUuMjUwMDIgNC42NDA2MiA1LjI1MDAyIDBaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfNjI0OF83Mzk3MSkiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl82MjQ4XzczOTcxIiB4MT0iNyIgeTE9IjAiIHgyPSI3IiB5Mj0iMTgiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0ZFQ0Y4OCIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGNzkzMUEiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";